import { render, staticRenderFns } from "./monitor-picture.vue?vue&type=template&id=54bef11a&"
import script from "./monitor-picture.vue?vue&type=script&lang=js&"
export * from "./monitor-picture.vue?vue&type=script&lang=js&"
import style0 from "./monitor-picture.vue?vue&type=style&index=0&id=54bef11a&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports